import { render, staticRenderFns } from "./DefaultAffirm.vue?vue&type=template&id=5b18023c&"
import script from "./DefaultAffirm.vue?vue&type=script&lang=js&"
export * from "./DefaultAffirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports